(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react'), require('prop-types')) : typeof define === 'function' && define.amd ? define(['react', 'prop-types'], factory) : global.ReactRipples = factory(global.React, global.PropTypes);
})(this, function (React, PropTypes) {
  'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var wrapStyleDefault = {
    position: 'relative',
    display: 'inline-block',
    overflow: 'hidden'
  };
  var Ripples = function (_PureComponent) {
    _inherits(Ripples, _PureComponent);
    function Ripples(props) {
      _classCallCheck(this, Ripples);
      var _this = _possibleConstructorReturn(this, (Ripples.__proto__ || Object.getPrototypeOf(Ripples)).call(this, props));
      _this.handleClick = function (ev) {
        if (ev.stopPropagation) {
          ev.stopPropagation();
        }
        var _this$props = _this.props,
          onClick = _this$props.onClick,
          during = _this$props.during;
        var pageX = ev.pageX,
          pageY = ev.pageY,
          _ev$currentTarget = ev.currentTarget,
          offsetLeft = _ev$currentTarget.offsetLeft,
          offsetTop = _ev$currentTarget.offsetTop,
          offsetWidth = _ev$currentTarget.offsetWidth,
          offsetHeight = _ev$currentTarget.offsetHeight;
        var left = pageX - offsetLeft;
        var top = pageY - offsetTop;
        var size = Math.max(offsetWidth, offsetHeight);
        _this.setState({
          rippleStyle: Object.assign({}, _this.state.rippleStyle, {
            top: top,
            left: left,
            opacity: 1,
            transform: 'translate(-50%, -50%)',
            transition: 'initial'
          })
        });
        _this.timer = setTimeout(function () {
          _this.setState({
            rippleStyle: Object.assign({}, _this.state.rippleStyle, {
              opacity: 0,
              transform: 'scale(' + size / 9 + ')',
              transition: 'all ' + during + 'ms'
            })
          });
        });
        if (typeof onClick === 'function') {
          onClick(ev);
        }
      };
      _this.state = {
        rippleStyle: {
          position: 'absolute',
          borderRadius: '50%',
          opacity: 0,
          width: 35,
          height: 35,
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none',
          backgroundColor: props.color
        }
      };
      return _this;
    }
    _createClass(Ripples, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        clearTimeout(this.timer);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
          children = _props.children,
          style = _props.style,
          during = _props.during,
          color = _props.color,
          props = _objectWithoutProperties(_props, ['children', 'style', 'during', 'color']);
        var state = this.state,
          handleClick = this.handleClick;
        var wrapStyle = Object.assign({}, style, wrapStyleDefault);
        return React__default.createElement('div', Object.assign({}, props, {
          style: wrapStyle,
          onClick: handleClick
        }), children, React__default.createElement('s', {
          style: state.rippleStyle
        }));
      }
    }]);
    return Ripples;
  }(React.PureComponent);
  Ripples.propTypes = {
    during: PropTypes.number,
    color: PropTypes.string,
    onClick: PropTypes.func
  };
  Ripples.defaultProps = {
    during: 600,
    color: 'rgba(0, 0, 0, .3)',
    onClick: function onClick() {}
  };
  return Ripples;
});